
<main-form-modal (toggleChange)="setVal($event)"> 
    <ng-template #customHtmlElements>
        <div [ngSwitch]="editMode">           
            <shtibel-edit *ngSwitchCase="true"></shtibel-edit>
            <shtibel-details *ngSwitchCase="false"></shtibel-details>
        </div>
    </ng-template>  
</main-form-modal>